import { Controller } from "@hotwired/stimulus";

class PriceRangeController extends Controller {
  static targets = [
    "lowerRange",
    "rangeFrom",
    "rangeTo",
    "textRange",
    "upperRange",
  ];

  static outlets = ["plp-filters"];

  connect() {
    this.#fillSlider();

    this.#renderInput();
  }

  #renderInput() {
    ["rangeToTarget", "rangeFromTarget", "textRangeTarget"].forEach(
      (target) => {
        this[target].classList.toggle("tw-opacity-0");
      },
    );
  }

  #formatMoney(value) {
    return `€${Number(value)}`;
  }

  #fillSlider() {
    const rangeDistance = this.rangeToTarget.max - this.rangeToTarget.min;
    const fromPosition = this.rangeFromTarget.value - this.rangeToTarget.min;
    const toPosition = this.rangeToTarget.value - this.rangeToTarget.min;

    const sliderColor = "#F1F3F4";
    const rangeColor = "#001B67";

    this.rangeToTarget.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} 100%)`;
  }

  getLowerRange(e) {
    e.preventDefault();

    this.lowerRangeTarget.innerHTML = this.#formatMoney(e.target.value);
    this.rangeFromTarget.value = e.target.value;

    this.#fillSlider();
  }

  getUpperRange(e) {
    e.preventDefault();

    this.upperRangeTarget.innerHTML = this.#formatMoney(e.target.value);
    this.rangeToTarget.value = e.target.value;

    this.#fillSlider();
  }

  submit(e) {
    e.preventDefault();

    this.plpFiltersOutlet.submitForm();
  }
}

Stimulus.register("price-range", PriceRangeController);
